import React from "react";
// import "./viewCustomerCare.css";

const ViewCustomerCare = ({ viewData }) => {
  // Define the fields to display
  const displayFields = [
    {
      row: [
        { label: "Service Name", key: "serviceName" },
        { label: "Product Name", key: "productName" }
      ]
    },
    {
      row: [
        { label: "Mobile Number", key: "msisdn" },
        { label: "Product Type", key: "productType" }
      ]
    },
    {
      row: [
        { label: "Subscription Date", key: "subscriptionDate" },
        { label: "Expiry Date", key: "expiryDate" }
      ]
    },
    {
      row: [
        { label: "Amount", key: "amount", prefix: "" },
        { label: "Price", key: "price", prefix: "" }
      ]
    },
    {
      row: [
        { label: "Channel", key: "channel" },
        { label: "Status", key: "activeStatus", isStatus: true }
      ]
    }
  ];

  // Helper function to render status
  const renderStatus = (status) => {
    return status === 1 ? (
      <span className="badge text-bg-success">Active</span>
    ) : (
      <span className="badge text-bg-danger">Inactive</span>
    );
  };

  return (
    <div className="card mt-4 position-relative view-customer-care">
    <span className="mt-2 mb-3 fw-bold badge_head text-center">
      Subscription Details
    </span>
      
      {displayFields.map((section, index) => (
        <div className="row  mb-3  row_div pt-4 px-4" key={index}>
          {section.row.map((field, fieldIndex) => (
            <div className="form-group col-sm-6 view-col mb-0" key={fieldIndex}>
              <div className="row inner-row  mobile-line-row m-0">
                <div className="col-sm-6 label">
                  <span>{field.label}</span>
                  <span>:</span>
                </div>
                <div className="col-sm-6 fw-bold text-wrap cont_div">
                  {field.isStatus ? (
                    renderStatus(viewData[field.key])
                  ) : (
                    <>
                      {field.prefix || ''}
                      {viewData[field.key] || 'N/A'}
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ViewCustomerCare;
